import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import DocumentsPanel from "./DocumentsPanel";

// Per-candidate document management modal (#1013), opened from the candidate
// table row actions. Uploads and library links target the candidate's
// TrackEntity; the docs feed the candidate's evaluation as internal_upload
// evidence.

interface CandidateDocumentsModalProps {
  open: boolean;
  onClose: () => void;
  trackEntityId: string;
  entityKgId?: string;
  entityName?: string;
}

const CandidateDocumentsModal: React.FC<CandidateDocumentsModalProps> = ({
  open,
  onClose,
  trackEntityId,
  entityKgId,
  entityName,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>
      Documents{entityName ? ` — ${entityName}` : ""}
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Documents attached to this candidate are taken into account when it is
        evaluated
      </Typography>
      <DocumentsPanel
        trackEntityId={trackEntityId}
        entityKgId={entityKgId}
        entityName={entityName}
        dropZone={false}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default CandidateDocumentsModal;
